import { mainApiInstance } from "./_axiosInstance";

export const healthService = {
  getHealth: async () => {
    const response = await mainApiInstance.get("/health");
    return response.data;
  },
};
